<micro-picklist title="API Keys"
                [all]="all"
                [listMinSize]="listMinSize"
                [(selectedIds)]="selectedItems"
                (selectedIdsChange)="onNgModelChange($event)">
</micro-picklist>

